export enum EApiAutomationResource {
  tagDefinition = 'tag-definition',
  changeActivity = 'change-activity',
  changeStationActivity = 'change-station-activity',
  faultCodeMapping = 'fault-code-mapping',
  heartbeatSettings = 'heartbeat-settings',
  sensorIdMapping = 'sensor-id-mapping',
  workOrderSettings = 'work-order-settings',
  burstSettings = 'burst-settings',
  lineWatchdogSettings = 'line-watchdog-settings',
  tagCombinations = 'tag-combinations',
  stationCombinations = 'station-combinations',
  loadBalancerAllocations = 'load-balancer-allocations',
  loadBalancerChannels = 'load-balancer-channels',
}

/**
 * `tag_definitions.tagType` decides which table `destinationTableId` points at. The API rejects a
 * destination id that does not exist in the matching table with `destinationNotFound`, and a tag
 * type without a destination table with `unknownTagType`.
 */
export enum ETagType {
  activityChange = 'activityChange',
  sensorValue = 'sensorValue',
  workOrder = 'workOrder',
  failureReason = 'failureReason',
  heartbeat = 'heartbeat',
  stationChange = 'stationChange',
  stationFailureReason = 'stationFailureReason',
  combinations = 'combinations',
  combinValueCleaner = 'combinValueCleaner',
}

export const TAG_TYPE_DESTINATION_RESOURCE: Readonly<Record<ETagType, EApiAutomationResource>> = {
  [ETagType.activityChange]: EApiAutomationResource.changeActivity,
  [ETagType.sensorValue]: EApiAutomationResource.sensorIdMapping,
  [ETagType.workOrder]: EApiAutomationResource.workOrderSettings,
  [ETagType.failureReason]: EApiAutomationResource.faultCodeMapping,
  [ETagType.heartbeat]: EApiAutomationResource.heartbeatSettings,
  [ETagType.stationChange]: EApiAutomationResource.changeStationActivity,
  [ETagType.stationFailureReason]: EApiAutomationResource.faultCodeMapping,
  [ETagType.combinations]: EApiAutomationResource.tagCombinations,
  [ETagType.combinValueCleaner]: EApiAutomationResource.tagCombinations,
};

/**
 * `tag_combinations.destinationTableId` points at change_activity for `activityChange` and at
 * change_station_activity for `stationChange`. No other tag type carries a destination here.
 */
export const TAG_COMBINATION_DESTINATION_RESOURCE: Readonly<Partial<Record<ETagType, EApiAutomationResource>>> = {
  [ETagType.activityChange]: EApiAutomationResource.changeActivity,
  [ETagType.stationChange]: EApiAutomationResource.changeStationActivity,
};

/**
 * A dropdown entry. `id` is a string for the enum-backed columns (`tagType`, `valueOperator`) and a
 * number for every foreign-key column.
 */
export interface IApiAutomationOption {
  id: number | string;
  name: string;
}

export interface IApiAutomationQueryParams {
  page: number;
  perPage: number;
  searchText?: string;
  orderBy?: string;
  orderDesc?: string;
  siteIds?: number[];
  lineIds?: number[];
}
